import React, { FC } from "react";

const DocumentViewer: FC<{ docType: "image" | "pdf" | "video"; url: string }> = ({
  docType,
  url,
}) => {
  return (
    <>
      {docType === "image" ? (
        <img
          src={url}
          alt="Document preview"
          className="h-full w-full object-contain"
          loading="lazy"
          decoding="async"
          fetchPriority="auto"
        />
      ) : docType === "pdf" ? (
        <iframe
          src={url}
          className="h-full w-full br-10"
          style={{ pointerEvents: "none" }}
          title="PDF Preview"
          loading="lazy"
        />
      ) : docType === "video" ? (
        <video
          src={url}
          controls
          preload="metadata"
          playsInline
          className="h-full w-full object-contain br-10"
        />
      ) : null}
    </>
  );
};

export default DocumentViewer;
